import { useEffect, useRef } from 'react';
import { useAppSelector } from 'store/hooks';
import { boardDiagnostics } from 'modules/overlay-v2/domain/utils/board-diagnostics';
import { selectBroadCastState, selectIsMatchAvailable } from 'modules/overlay-v2/store/overlay/selectors';
import { selectPeriod } from 'modules/overlay-v2/store/time/selectors';
import { selectActiveBoard } from 'modules/template-editor/store/templates/selectors';

/**
 * Второй срез замера (IMGM-1435): что из пришедшего осело в сторе.
 *
 * Пара «пришло по realtime → легло в стор» разделяет причины. Период, скачущий 1 ↔ 2 без
 * входящего `realtime:time`, означает, что его обнулил код — а обнуляет его ровно один путь:
 * пропажа `matchId` (`use-init-subscribe-overlay-v2.ts:41-51`), он же гасит табло.
 */
function useBoardDiagnosticsStore() {
  const { matchId } = useAppSelector(selectBroadCastState);
  const isMatchAvailable = useAppSelector(selectIsMatchAvailable);
  const period = useAppSelector(selectPeriod);
  const activeBoardId = useAppSelector(selectActiveBoard)?.id;

  const previous = useRef<Record<string, unknown>>({});

  useEffect(() => {
    const next = { matchId, isMatchAvailable, period, activeBoardId };

    Object.entries(next).forEach(([key, value]) => {
      if (previous.current[key] === value) return;
      boardDiagnostics.record(`store:${key}`, { from: previous.current[key] ?? null, to: value ?? null });
    });

    previous.current = next;
  }, [activeBoardId, isMatchAvailable, matchId, period]);
}

export default useBoardDiagnosticsStore;
